module.exports = __webpack_public_path__ + "../resources/img/ico-module-copy.24fc8621.svg";